import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function Footer() {
  return (
    <footer className="bg-background-100 mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                91
              </div>
              <span className="text-foreground-950 font-semibold text-lg">
                免费91网页
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费91网页为您提供便捷的在线网页服务，无需注册即可免费访问全部内容。科技、生活、娱乐、教育、健康等多元内容，满足您日常上网需求。
            </p>
          </div>

          <div>
            <h4 className="text-foreground-950 font-semibold mb-4 text-sm">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-950 font-semibold mb-4 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  服务条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-950 font-semibold mb-4 text-sm">
              联系我们
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@91web.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500"></i>
                <span>400-888-9191</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500"></i>
                <span>北京市朝阳区科技园路91号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2025 免费91网页 版权所有 | 京ICP备2025000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}